import { useAuth } from '$features/auth/hooks/use-auth'
import { useTenant } from '$features/auth/hooks/use-tenant'
import { LinkButton, Text } from '$components'
import { ClockIcon, LinkIcon } from '$components'
import { Config } from '$config/app'

export function SubscriptionExpiryBanner() {
  const { hasSubscriptionExpired } = useTenant()
  const { user } = useAuth()

  if (!hasSubscriptionExpired) {
    return null
  }

  return (
    <div className="w-full bg-brand p-stack-tight flex flex-col gap-stack sm:flex-row sm:items-center sm:justify-between sm:gap-0">
      <div className="flex items-start gap-stack">
        <ClockIcon className="min-w-5 min-h-5 size-5 text-fg-inverse mt-stack-dense" />
        <div className="flex-1">
          <Text
            type="s"
            className="text-fg-inverse"
          >
            Your subscription has expired
          </Text>
          <Text
            type="s"
            className="text-fg-inverse font-light leading-relaxed"
          >
            You can still access all of your data, but will not be able to create new records or update existing ones. Upgrade to continue using Tailly.
          </Text>
        </div>
      </div>

      <LinkButton
        to={Config.getStripeBillingUrl(user!.email)}
        variant="secondary"
        className="border-transparent w-full sm:w-auto sm:ml-stack-roomy"
        icon={LinkIcon}
      >
        Upgrade your plan
      </LinkButton>
    </div>
  )
}
